// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"9adbe996","682":"ec1439a4","783":"db471568","893":"71a1495d"}[chunkId] + ".chunk.js";
};